import iconTargetLocation from "assets/img/icon-target-location.svg"
import iconWarehouse from "assets/img/icon-warehouse.svg"
import iconPlus from "assets/img/icon-plus.svg"

import { FC, ReactElement, useCallback } from "react"

import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import Text from "components/Text/Text"
import Tooltip from "components/Tooltip/Tooltip"
import RequestLocation, { RequestLocationType } from "models/RequestLocation"
import { Guid } from "@/types"
import { Grid } from "components/Grid"

interface IShippingOrderLocationItemProps {
    locations: RequestLocation[] | null
    locationId?: Guid
    label: string
    highlight?: string
}

const ShippingOrderLocationItem: FC<IShippingOrderLocationItemProps> = ({
    locations,
    locationId,
    label,
    highlight,
}) => {
    const renderTooltipContent = useCallback((title: ReactElement | string, address: RequestLocation["address"] | null) => {
        return <Text>
            <div className="font-bold">{title}</div>
            {!!address && address.print()}
        </Text>
    }, [])

    const labelEl = <FlexibleContent clampedTooltip={false} text={label} highlight={highlight} />

    if (!locationId) {
        return <Grid columns="max-content minmax(0, auto)" gap="0.8rem" alignItems="center">
            <img src={iconPlus} alt="" />
            {labelEl}
        </Grid>
    }

    const requestLocation = locations?.find(rl => rl.id === locationId)
    let el: ReactElement
    switch (requestLocation?.type) {
        case RequestLocationType.eventLocation: {
            el = <Grid columns="max-content minmax(0, auto)" gap="0.8rem" alignItems="center">
                <img src={iconTargetLocation} alt="" />
                {labelEl}
            </Grid>
            break
        }
        case RequestLocationType.warehouse: {
            el = <Grid columns="max-content minmax(0, auto)" gap="0.8rem" alignItems="center">
                <img src={iconWarehouse} alt="" />
                {labelEl}
            </Grid>
            break
        }
        default: {
            el = labelEl
        }
    }
    return (
        <Tooltip
            trigger="hover"
            delayShow={500}
            content={renderTooltipContent(label, requestLocation?.address || null)} >
            {el}
        </Tooltip>
    )
}

export default ShippingOrderLocationItem
